export default __webpack_public_path__ + "static/media/driver.320a5956.png";